export default "__VITE_ASSET__NYk0x9ma__"